import { translate } from "app/language/service"
import { messageSVC } from "message/service"
import { IUserUiSettings } from "user/model"
import { getUser, updateCurrentUser } from "user/tools/common"

export function addImportant(cssValue: string | number): string {
  return `${cssValue} !important`
}

export const getRandomColorFromString = (text: string) => {
  let hash = 0
  let i
  for (i = 0; i < text.length; i += 1) {
    /* eslint-disable no-bitwise */
    hash = text.charCodeAt(i) + ((hash << 5) - hash)
  }
  let color = "#"
  for (i = 0; i < 3; i += 1) {
    /* eslint-disable no-bitwise */
    const value = (hash >> (i * 8)) & 0xff
    color += `00${value.toString(16)}`.slice(-2)
  }
  return color
}

export const saveUserUiPreferences = (data: Partial<IUserUiSettings>): Promise<void> =>
  new Promise<void>(resolve => {
    updateCurrentUser({ ui_settings: { ...getUser().ui_settings, ...data } })
      .catch(error => {
        console.error(error)
        messageSVC.error(translate("user.save.ui.preference.error"))
      })
      .finally(() => resolve())
  })

export const openGoogleStreetviewTab = (lat: number, lon: number): void => {
  const url = `https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=${lat},${lon}`
  window.open(url, "_blank")
}
